import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HelpPageComponent} from '../../../help-page.component';
import {environment} from '../../../../../../../environments/environment';

@Component({
    selector: 'app-help-page-equipment-olse',
    templateUrl: './help-page-equipment-olse.component.html',
    styleUrls: ['./help-page-equipment-olse.component.scss', '../../../helpPageModule.scss'],
    standalone: false
})
export class HelpPageEquipmentOlseComponent extends HelpPageComponent implements OnInit
{


    urlLanguage: string;

    constructor(public translate: TranslateService)
    {
        super(translate);
    }

    ngOnInit(): void
    {
        this.urlLanguage = this.translate.currentLang;
    }
    public readonly environment = environment;

}
